import { Controller } from "@hotwired/stimulus";
import { setTriggerExpanded } from "../../utils/disclosure.js";

/** GO4S DS — Dropdown menu (ouvre/ferme, clic-extérieur, Échap). */
export default class extends Controller {
  static targets = ["panel", "trigger"];
  connect() { this.onDoc = this.onDoc.bind(this); this.onKey = this.onKey.bind(this); }
  disconnect() { this.unbind(); }
  setExpanded(v) { setTriggerExpanded(this, v); }
  toggle() { this.panelTarget.hidden ? this.open() : this.close(); }
  open() { this.panelTarget.hidden = false; this.setExpanded(true); document.addEventListener("mousedown", this.onDoc); document.addEventListener("keydown", this.onKey); }
  close() { this.panelTarget.hidden = true; this.setExpanded(false); this.unbind(); }
  unbind() { document.removeEventListener("mousedown", this.onDoc); document.removeEventListener("keydown", this.onKey); }
  onDoc(e) { if (!this.element.contains(e.target)) this.close(); }
  onKey(e) { if (e.key === "Escape") this.close(); }
}
